import React from 'react'
import * as Select from '@radix-ui/react-select'

import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@radix-ui/react-icons'

import {
  Container,
  SelectContent,
  SelectIcon,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectTrigger,
  SelectViewport,
  StyledItem,
  StyledItemIndicator,
} from './styles'

export const Subselect = ({
  name,
  label,
  data,
  defaultValue,
  onValueChange,
}) => (
  <Container>
    <Select.Root onValueChange={onValueChange} defaultValue={defaultValue}>
      <SelectTrigger aria-label={name}>
        <Select.Value placeholder={label} />
        <SelectIcon>
          <ChevronDownIcon />
        </SelectIcon>
      </SelectTrigger>
      <Select.Portal>
        <SelectContent>
          <SelectScrollUpButton>
            <ChevronUpIcon />
          </SelectScrollUpButton>
          <SelectViewport>
            <Select.Group>
              <SelectLabel>{name}</SelectLabel>
              {data.map((item) => (
                <StyledItem key={item.value} value={item.value}>
                  <Select.ItemText>{item.label}</Select.ItemText>
                  <StyledItemIndicator>
                    <CheckIcon />
                  </StyledItemIndicator>
                </StyledItem>
              ))}
            </Select.Group>
          </SelectViewport>
          <SelectScrollDownButton>
            <ChevronDownIcon />
          </SelectScrollDownButton>
        </SelectContent>
      </Select.Portal>
    </Select.Root>
  </Container>
)
